var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button-icon white",class:{active:_vm.handler=='bold'},on:{"click":_vm.toggle}},[_c('font-icon',{attrs:{"icon":"bold"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }